import { all } from "redux-saga/effects";

import {
  getInvoiceHistorySaga,
  getUpcomingInvoiceSaga,
  getStripeInvoiceSaga,
  getStripeUpcomingInvoiceSaga,
  getTimeperiodDetailSaga,
  getUserCardsSaga,
  getCashfreeCreateSubscriptionSaga,
  getCashfreeUpdateSubscriptionSaga,
  getStripeCreateSubscriptionSaga,
  getStripeUpdateSubscriptionSaga,
  getStripeUpdateAddonSubscriptionSaga,
  getStripePublishableKey,
  getCashfreeDiscount,
  createStagingStripeSubscription,
  createStagingCashfreeSubscription,
  createStorageStripeSubscription,
  createStorageCashfreeSubscription,
  createPerformanceUpgradeStripeCheckout,
  createPerformanceUpgradeCashfreeCheckout,
  getCashfreeAddons,
  apiFetchStatus,
} from "./payments";

import { apiSpecificPlan, getAllPlansSaga, apiAllLicenses } from "./plans";
import {
  createOrgSaga,
  getAllOrgsSaga,
  getDashboardOrg,
  getOrganizationSagas,
  getUserOrgsSaga,
  isValidOrgName,
  updateSelectedOrgSaga,
  changeOrgNameSaga,
  changeOrgOwnerSaga,
  deleteOrgSaga,
  changeOrgMemberRoleSaga,
  deleteMemberFromOrgSaga,
  getOrgActivitiesSaga,
  userActivitySaga,
  apiTimePeriodGraphData,
  selectedOrgSaga,
  inviteUsersSaga,
  apiFetchChildOrgDetailsSaga,
  apiFetchChildOrgsSaga,
  orgImage,
  bulkInviteUsersSaga,
  orgImageDelete,
  apiGetChildOtpSaga,
  apiVerifyChildOtpSaga,
  childOrgCountryChange,
  apiChildOrgs,
  apiGetOrgAddressSaga,
} from "./organizations";

import {
  getAllUsersSaga,
  getOrgInvitationsForUserSaga,
  getUserDetails,
  updateOrgUserInvitationSaga,
  userNotifications,
  markNotificationsRead,
  updateUserDetails,
  usersApi,
  checkUserPlan,
  isUserPartOfOrg,
  apiGetTheme,
} from "./user";

import {
  apiAlertDetails,
  apiGetBackups,
  apiGetOndemandBackups,
  apiUpdateWAF,
  createSftpUser,
  deleteSelectedSiteFile,
  getAllSites,
  getSelectedSite,
  getSelectedSiteFiles,
  listSftpUser,
  ebsSftpDetails,
  setDomain,
  ebsSiteDomains,
  siteRestores,
  isValidSiteName,
  getLbName,
  setWpCache,
  setWpDebug,
  deleteSite,
  setSiteRestore,
  getEbsBackups,
  setEbsSiteRestore,
  setEbsCreateBackup,
  setSiteDownload,
  apiSiteImages,
  apiDeleteImages,
  getS3PresignedUrl,
  cacheInvalidation,
  downloadSelectedSiteFile,
  downloadSelectedSiteFolder,
  tagName,
  getLabel,
  deleteDomain,
  setSitesDomainSslStatus,
  uploadFile,
  deleteSftpUser,
  makeTempDoaminLive,
  getSslStatus,
  apiWpVersionUpdate,
  getGraph,
  siteOverview,
  topSitesSagas,
  sitesList,
  createStaging,
  deleteStaging,
  apiToggleStaging,
  apiSubmitMigrateDetails,
  apiStagingDomain,
  apiCommand,
  apiStagingTimestamp,
  migrationProgress,
  apiAutoLogin,
  apiPlanOvergauge,
  apiSslhandler,
  apiDownloadInstanceKeySaga,
  apiGetInstancePasswordSaga,
  apiInstallDomainSaga,
  restoreDedicatedSiteSaga,
  dedicatedOnDemandSaga,
  dedicatedStorageSaga,
  dedicatedPhpCredsSaga,
  checkDnsStatusSaga,
} from "./sites";
import {
  apiCreateBlueprint,
  apiDeleteBlueprint,
  apiRenameBlueprint,
  apiGetAllBlueprint,
  apiIsValidBluePrintName,
  getAllSpecificBlueprints,
  apiImageUploadBp,
  apiRemoveBlueprintImage,
} from "./bluePrint";

import {
  createNewEnvironment,
  createNewSite,
  getCreateSiteSelectedOrg,
} from "./createSite";

import { sendFeedback, sendInviteToHelpCenter } from "./support";

// import { create } from "@mui/material/styles/createTransitions";

export function* rootSaga() {
  yield all([
    // Organization
    selectedOrgSaga(),
    getAllPlansSaga(),
    createOrgSaga(),
    getDashboardOrg(),
    getAllOrgsSaga(),
    getOrganizationSagas(),
    getUserOrgsSaga(),
    isValidOrgName(),
    getOrgInvitationsForUserSaga(),
    updateOrgUserInvitationSaga(),
    getUserDetails(),
    getAllUsersSaga(),
    apiSpecificPlan(),
    getAllSites(),
    getSelectedSite(),
    apiAlertDetails(),
    siteRestores(),
    apiGetBackups(),
    apiGetOndemandBackups(),
    apiUpdateWAF(),
    createSftpUser(),
    getSelectedSiteFiles(),
    deleteSelectedSiteFile(),
    apiFetchChildOrgDetailsSaga(),
    apiFetchChildOrgsSaga(),
    updateSelectedOrgSaga(),
    changeOrgNameSaga(),
    changeOrgOwnerSaga(),
    deleteOrgSaga(),
    changeOrgMemberRoleSaga(),
    deleteMemberFromOrgSaga(),
    inviteUsersSaga(),
    bulkInviteUsersSaga(),
    getOrgActivitiesSaga(),
    userActivitySaga(),
    apiTimePeriodGraphData(),
    getCashfreeCreateSubscriptionSaga(),
    getCashfreeUpdateSubscriptionSaga(),
    getStripeCreateSubscriptionSaga(),
    getStripeUpdateSubscriptionSaga(),
    getStripeUpdateAddonSubscriptionSaga(),
    getStripePublishableKey(),
    getCashfreeDiscount(),
    getCashfreeAddons(),
    apiFetchStatus(),
    apiGetChildOtpSaga(),
    apiVerifyChildOtpSaga(),
    childOrgCountryChange(),
    apiChildOrgs(),
    createStagingStripeSubscription(),
    createStagingCashfreeSubscription(),
    createStorageStripeSubscription(),
    createStorageCashfreeSubscription(),
    createPerformanceUpgradeStripeCheckout(),
    createPerformanceUpgradeCashfreeCheckout(),
    apiGetOrgAddressSaga(),
    apiGetTheme(),
    // BluePrints
    apiCreateBlueprint(),
    apiDeleteBlueprint(),
    apiRenameBlueprint(),
    apiGetAllBlueprint(),
    apiIsValidBluePrintName(),
    getAllSpecificBlueprints(),
    apiImageUploadBp(),
    apiRemoveBlueprintImage(),
    // CreateSite
    createNewEnvironment(),
    createNewSite(),
    getCreateSiteSelectedOrg(),
    // Sites
    getAllPlansSaga(),
    getUpcomingInvoiceSaga(),
    getInvoiceHistorySaga(),
    getStripeInvoiceSaga(),
    getStripeUpcomingInvoiceSaga(),
    getTimeperiodDetailSaga(),
    getUserCardsSaga(),
    listSftpUser(),
    ebsSftpDetails(),
    setDomain(),
    ebsSiteDomains(),
    apiAllLicenses(),
    isValidSiteName(),
    getLbName(),
    deleteSite(),
    apiSiteImages(),
    apiDeleteImages(),
    getGraph(),
    topSitesSagas(),
    sitesList(),
    createStaging(),
    deleteStaging(),
    apiToggleStaging(),
    apiSubmitMigrateDetails(),
    apiStagingDomain(),
    apiCommand(),
    migrationProgress(),
    apiAutoLogin(),
    apiSslhandler(),
    apiDownloadInstanceKeySaga(),
    apiGetInstancePasswordSaga(),
    apiInstallDomainSaga(),
    restoreDedicatedSiteSaga(),
    dedicatedOnDemandSaga(),
    dedicatedStorageSaga(),
    dedicatedPhpCredsSaga(),
    checkDnsStatusSaga(),
    // DevTools
    setWpCache(),
    setWpDebug(),
    setSiteRestore(),
    getEbsBackups(),
    setEbsSiteRestore(),
    setEbsCreateBackup(),
    setSiteDownload(),
    getS3PresignedUrl(),
    cacheInvalidation(),
    downloadSelectedSiteFile(),
    downloadSelectedSiteFolder(),
    tagName(),
    getLabel(),
    // Notifications
    userNotifications(),
    markNotificationsRead(),
    updateUserDetails(),
    checkUserPlan(),
    isUserPartOfOrg(),
    deleteDomain(),
    setSitesDomainSslStatus(),
    uploadFile(),
    orgImage(),
    usersApi(),
    deleteSftpUser(),
    makeTempDoaminLive(),
    getSslStatus(),
    orgImageDelete(),
    sendInviteToHelpCenter(),
    apiWpVersionUpdate(),
    siteOverview(),
    apiStagingTimestamp(),
    //support
    sendFeedback(),
    apiPlanOvergauge(),
  ]);
}
